"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TokenContextProvider = exports.useToken = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var TokenContext = /*#__PURE__*/_react["default"].createContext();
var TokenContextProvider = function TokenContextProvider(props) {
  var _useState = (0, _react.useState)(props.token),
    token = _useState[0],
    updateToken = _useState[1];
  var setToken = function setToken(newToken) {
    updateToken(newToken);
    _jsCookie["default"].set(global.__appConfig__.tokenCookieName, newToken, {
      secure: true,
      expires: parseInt(global.__appConfig__.sessionUserLoginMaxDays)
    });
  };
  var deleteToken = function deleteToken() {
    var _localStorage, _localStorage2;
    updateToken(undefined);
    _jsCookie["default"].remove(global.__appConfig__.tokenCookieName);
    _jsCookie["default"].remove("cartId");
    (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.setItem("minicartContent", "[]");
    (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.removeItem("cartId");
  };
  return __jsx(TokenContext.Provider, {
    value: {
      token: token,
      setToken: setToken,
      deleteToken: deleteToken
    }
  }, props.children);
};
exports.TokenContextProvider = TokenContextProvider;
var useToken = function useToken() {
  return (0, _react.useContext)(TokenContext);
};
exports.useToken = useToken;